import React, { useState, memo, useEffect } from "react";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const EditOption = memo((props) => {
  const { init_service_option, removeServiceOption } = props;
  const [currentEditOption, setCurrentEditOption] = useState(init_service_option);

  const notify = (type, message) => {
    if (type === "success") {
      toast.success(message, {
        hideProgressBar: true
      });
    } else {
      toast.error(message, {
        hideProgressBar: true
      });
    }
  }

  const onChangeData = (e) => {
    setCurrentEditOption({
      ...currentEditOption,
      [e.target.name]: e.target.value,
    })
  };

  const onClinicServiceOptionUpdate = () => {
    var data = {
      service_option: {
        price: parseInt(currentEditOption.price, 10),
        note: currentEditOption.note,
      },
      id: currentEditOption.id,
    }

    // axios csrfToken
    const csrfToken = document.querySelector('[name=csrf-token]').content
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

    axios.patch(`/api/v1/service_options/${currentEditOption.id}`, data)
    .then(resp => {
      console.log(resp.data);
      notify("success", "ServiceOption successfully updated!");
    })
    .catch(e => {
      console.log(e.response);
      setCurrentEditOption({ 
        ...currentEditOption,
        price: init_service_option.price,
        note: init_service_option.note,
      });
      alert(JSON.parse(e.request.responseText).errors);
      notify("error", "ServiceOption updated Error!");
    })
  }

  const onClickDeleteSubmit = (id) => {
    const sure = window.confirm('Are you sure?');
    if (sure) {
      // axios csrfToken
      const csrfToken = document.querySelector('[name=csrf-token]').content
      axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

      axios.delete(`/api/v1/service_options/${id}`)
      .then(resp => {
        console.log(resp);
        removeServiceOption(id);
        notify("success", "ServiceOption successfully deleted!");
      })
      .catch(e => {
        console.log(e.response);
        notify("error", "ServiceOption delete Error!");
      })
    }
  }

  return (
    <>
      <tr>
        <th scope="row" className="col-3">{currentEditOption.option_name_ja}</th>
        <td className="col-3">
          <div className="input-group">
            <span className="input-group-text">料金</span>
            <input type="number" name="price" className="form-control" value={currentEditOption.price} placeholder="半角数字必須" onChange={onChangeData} />
          </div>
        </td>
        <td className="col-4">
          <div className="input-group">
            <span className="input-group-text">備考</span>
            <textarea type="text" name="note" className="form-control" rows="1" placeholder="※OP備考" value={currentEditOption.note || ''} onChange={onChangeData}></textarea>
          </div>
        </td>
        <td className="col-2">
          <button className="btn btn-success mr-1" onClick={onClinicServiceOptionUpdate} disabled={(!currentEditOption.option_id || !currentEditOption.price)}>
            <i className="fa fa-share-square" />
          </button>
          <button className="btn btn-outline-danger" onClick={() => onClickDeleteSubmit(currentEditOption.id)}>
            <i className="far fa-trash-alt" />
          </button>
        </td>
      </tr>
    </>
  );
});